import './../scss/style.scss';
import view360 from './components/view360';

view360.init();